import React from 'react';

export const QuickTips = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="QuickTips">
      {React.Children.map(children, (child) => {
        if (child) {
          return <div className="QuickTips__item">{child}</div>;
        }
        return child;
      })}
    </div>
  );
};
